var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:""},[(_vm.banner)?_c('img',{staticClass:"login-img",attrs:{"src":_vm.banner,"alt":"login image"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }